var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNotifications = function SvgNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.249 16.5H1.75a1.74 1.74 0 0 1-1.478-.812 1.742 1.742 0 0 1-.106-1.683l1.333-2.68V8.19C1.5 4.07 4.635.697 8.638.509a7.454 7.454 0 0 1 5.538 2.064A7.433 7.433 0 0 1 16.5 8v3.324l1.325 2.667a1.75 1.75 0 0 1-1.576 2.51ZM8.674 1.258h.005-.005ZM6.044 17.5A3.002 3.002 0 0 0 9 20a3.002 3.002 0 0 0 2.955-2.5h-5.91Z",
    fill: "gray"
  })));
};

export default SvgNotifications;